import { FormType } from '@/store/types';

export default {
  variants: {
    [FormType.InvestmentLoan]: {
      title: 'Podnikatelský úvěr',
    },
    [FormType.ConsumerLoan]: {
      title: 'Rychlá půjčka na míru',
    },
  },
  title: 'Rychlá půjčka na míru',
  fields: {
    value: {
      label: 'Požadovaná výše úvěru',
      tooltip: 'Sdělte nám ideální výši úvěru, kterou potřebujete.',
      suffix: 'Kč',
    },
    installmentValue: {
      label: 'Kolik můžete měsíčně splácet?',
      tooltip: 'Dejte nám vědět, jakou částku jste schopni měsíčně splácet.',
      suffix: 'Kč',
    },
    purpose: {
      label: 'Na co úvěr v podnikání použijete?',
    },
    submit: {
      label: 'Pokračovat',
    },
  },
  valueErrors: {
    lowerThanValue: 'Splátka musí být nižší než půjčovaná částka',
  },
};
